<!-- Verify your email -->
<div class="container">
  <div class="row">
    <div class="col-md-8 col-lg-6 mx-auto verifyEmailForm">
      <div class="form-group row">
        <h6 class="fill-nightfall mx-auto">Verify your email</h6>
        <div class="col-12 text-center my-3 my-md-4">
          <img class="img-fluid img-verify-email" src="/assets/images/verify-email.png" alt="Privalgo Verify your email">
        </div>
      </div>
      <p class="fill-nightfall text-center mb-3 mb-md-5">
        Welcome to {{brandName}}, you entered
        <strong>{{registerInfo.email}}</strong> as the contact email address for your account, please check your inbox for the verification
        email that we have sent you.
      </p>
      <div>
        <button class="btn btn-block btn-greengo" type="button" (click)="onSubmit()" npFocusOutClicked>Email didn't arrive?</button>
      </div>
      <p class="footer">
        Go back to
        <a *ngIf="!isPrivalgoMarkets"outerLink="/auth/login" class="link">Privalgo.co.uk</a>
        <a *ngIf="isPrivalgoMarkets"outerLink="/auth/login" class="link">PrivalgoMarkets.co.uk</a>
      </p>
    </div>
  </div>
</div>